import { SharedState } from '@trello/shared-state';

interface BoardSwitcherSearchSharedState {
  query: string | null;
  searchFieldRef: React.RefObject<HTMLInputElement> | null;
}

export const defaultBoardSwitcherSearchSharedState: BoardSwitcherSearchSharedState =
  {
    query: null,
    searchFieldRef: null,
  };

export const boardSwitcherSearchSharedState = new SharedState(
  defaultBoardSwitcherSearchSharedState,
);
